import { Box, Heading, Position, Text } from '@trmediaab/zebra';
import { Spinner } from '@trmediaab/zebra-icons';
import type { CheckoutSite } from '@trmediaab/zebra-types/trhub';
import { brands } from '@trmediaab/zebra-utils';

import NextButton from '../../../components/NextButton';
import useAutoNavigationToProduct from '../../../utils/useAutoNavigationToProduct';

interface DoneProps {
  isLoading: boolean;
  site: CheckoutSite;
  hrefUrl: string;
  hrefText: string;
}

const Done = ({ isLoading, site, hrefUrl, hrefText }: DoneProps) => {
  const [navigationTimer] = useAutoNavigationToProduct(hrefUrl, !isLoading);

  const spinnerProps: React.ComponentProps<typeof Position.relative> = {
    transitionProperty: 'opacity, top',
    transitionDuration: '0.35s',
    transitionTimingFunction: 'ease-out',
    sx: {
      textAlign: 'center',
      top: !isLoading ? '0' : '100px',
    },
  };

  const contentProps: React.ComponentProps<typeof Text> = {
    transitionProperty: 'opacity, top',
    transitionDuration: '0.4s',
    transitionTimingFunction: 'ease-out',
    transitionDelay: '0.25s',
    sx: {
      position: 'relative',
      top: !isLoading ? '0' : '15px',
      opacity: !isLoading ? '100' : '0',
    },
  };

  return (
    <>
      <Position.relative {...spinnerProps}>
        <Spinner
          size="64px"
          css={`
            animation-timing-function: ${isLoading ? undefined : 'ease'};
            animation-duration: ${isLoading ? undefined : '4s'};
          `}
        />
      </Position.relative>
      <Heading.h4 variant="checkout" textAlign="center" {...contentProps}>
        Tack för ditt köp!
      </Heading.h4>
      <Text.p textAlign="center" px="4" {...contentProps}>
        Du skickas strax tillbaka till tipsmaterialet på{' '}
        {brands.getBrand(site).name}.
      </Text.p>
      <Text fontWeight="semiBold" textAlign="center" {...contentProps}>
        {Math.max(navigationTimer, 0)} sekunder
      </Text>
      <Box pt="2" {...contentProps}>
        <NextButton label={hrefText} href={hrefUrl} />
      </Box>
    </>
  );
};

export default Done;
